import { getHighlightVector, getStyledFeature } from '../../services/brk/markParcel';

const store = {
    state: {
        showAdvancedSearch: false,
        hasAnyApiLicense: false,
        userIsBrkAuthorized: false,
        cadastralModal: { parcelIdentificationLocalID: '', title: '' },
        parcelVector: null,
        parcelCoordinates: null,
        cadastralRealEstate: null
    },
    mutations: {
        SHOW_ADVANCED_SEARCH(state, show) {
            state.showAdvancedSearch = show === undefined ? !state.showAdvancedSearch : show;
        },

        SET_VECTOR(state, vector) {
            state.parcelVector = vector;
        },

        GET_CADASTRAL_REAL_ESTATE(state, data) {
            state.cadastralRealEstate = data;
        },

        SET_HAS_ANY_API_LICENSE(state, data) {
            state.hasAnyApiLicense = data;
        },

        SET_USER_IS_BRK_AUTHORIZED(state, data) {
            state.userIsBrkAuthorized = data;
        },
        // Contains the X Y coordinates of a parcel object
        SET_PARCEL_COORDINATES(state, data) {
            state.parcelCoordinates = data;
        },

        SET_CADASTRAL_MODAL(state, data) {
            state.cadastralModal = data;
        },
    },
    actions: {
        // Clear vector source
        clearParcelHighlight({ state }) {
            state.parcelVector?.getSource().clear();
        },

        // Highlight the contour of parcel for given coordinates
        setParcelContour({ commit, state, getters, dispatch }, geoCoordinate) {
            // Clear vector before drawing new one
            dispatch('clearParcelHighlight');
            if (state.parcelVector === null) {
                // Get new vector
                commit('SET_VECTOR', getHighlightVector(geoCoordinate));
                getters.map.addLayer(state.parcelVector);
            } else {
                // Update existing vector
                state.parcelVector.getSource().addFeature(getStyledFeature(geoCoordinate));
            }
        },

        // Gets the cadastral real estate data for given id
        async getCadastralRealEstate({ dispatch, commit }, parcelId) {
            const cadastralInfo = await dispatch('getData', { url: '/brk/getCadastralRealEstate', params: { ObjectId: parcelId } });
            commit('GET_CADASTRAL_REAL_ESTATE', cadastralInfo.data);
        },

        // Determines whether any Api is licensed for this organization
        async getHasAnyApiLicense({ dispatch, commit }) {
            const hasAnyApiLicens = await dispatch('useApiData', {
                name: 'GetHasAnyApiLicense'
            });
            commit('SET_HAS_ANY_API_LICENSE', hasAnyApiLicens?.data);
        },

    },
    getters: {
        anyParcelLayerEnabled: (__, getters) => {
            const themeOrFeedback = getters.allActiveLoadedThemes.find(element => {
                return element.themeLayers.find(getters.isWFSParcelLayer);
            });
            return themeOrFeedback !== undefined;
        }
    }
};

export default store;
